export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [{
      path: '/basis/job_title/promotion',
      method: 'GET'
    },
    {
      path: '/basis/worker_job_title/current',
      method: 'GET'
    }]
  },
  detail: {
    funKey: 'detail',
    name: '明细'
  }
}